import Link from "next/link";
import {SymbolCard} from "@/components/cards";
import {LOCAL_IMAGE_URL} from "@/constants/general-constants";
import {useSelector} from "react-redux";
import parse from "html-react-parser";
import {ImageWithFallback} from "@/components";
import {useEffect} from "react";
import {useInView} from "react-intersection-observer";

export default function Footer() {

    const layoutData = useSelector((state) => state.layout.data);
    const {footer = {}, contact = [], social_media = [], copyright = ""} = layoutData;

    const [ref, inView] = useInView();

    useEffect(() => {
        if (inView) {
            const elem = document.getElementById("footer");
            if (elem.classList.contains("invisible")) {
                elem.classList.remove("invisible")
            }
        }

    }, [inView]);

    return (
        <footer ref={ref} className="invisible lg:container lg:!px-5 xl:!px-7" id="footer">
            <div className="bg-pol-light-gray-2 rounded-t-[2.25rem] pt-11">
                <div className="px-[1.938rem] xl:px-[6.5rem] pb-11 lg:flex items-start gap-x-7 space-y-12 lg:space-y-0">
                    <div className="lg:basis-[40%] text-pol-dark-800">
                        <p className="font-bold text-lg lg:text-xl">{footer.footer_about?.title}</p>
                        <div className="mt-5 text-justify leading-[170%]">
                            {parse(footer.footer_about?.content || '<span></span>')}
                        </div>
                        <Link href="/about-us"
                              className="font-bold text-pol-blue inline-block mt-5 hover:brightness-75">
                            بیشتر بدانید ...
                        </Link>
                    </div>
                    <div className="lg:basis-[19%]">
                        <p className="font-bold text-lg lg:text-xl">لینک‌های ضروری</p>
                        <ul className="mt-5 space-y-2.5">
                            {
                                footer.footer_links?.map((item, index) => (
                                    <li key={index}>
                                        <Link href={item.link} className="services-item">{item.title}</Link>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>
                    <div className="lg:basis-[41%]">
                        <p className="font-bold text-lg lg:text-xl">نمادهای اعتماد</p>
                        <div className="grid grid-cols-3 gap-x-4 lg:gap-x-5 mt-5">
                            {/*{*/}
                            {/*    footer.footer_logos?.map((item, index) => (*/}
                            {/*        <SymbolCard*/}
                            {/*            key={logosIds[index]}*/}
                            {/*            image={IMAGE_URL + item.image}*/}
                            {/*            title={item.title}*/}
                            {/*        />*/}
                            {/*    ))*/}
                            {/*}*/}
                            <div
                                className="block relative flex-grow bg-white rounded-[1.563rem] px-3.5 py-4 lg:p-5 after:absolute after:w-[38%] after:rounded-[1.938rem] after:h-1 after:bg-pol-blue-light after:top-0 after:right-[31%] hover:brightness-100 after:duration-300 hover:after:bg-pol-purple"
                            >
                                <div
                                    className="relative w-full h-[5.5rem] lg:h-[6.625rem] overflow-hidden rounded-[0.938rem]">

                                    <a referrerPolicy='origin' target='_blank' className="h-full block" rel="nofollow"
                                       href='https://trustseal.enamad.ir/?id=186627&Code=IGaDaZ5eRrfjFFe2UFID'>
                                        <img
                                            referrerPolicy='origin'
                                            src='https://trustseal.enamad.ir/logo.aspx?id=186627&Code=IGaDaZ5eRrfjFFe2UFID'
                                            alt=''
                                            style={{cursor: "pointer"}}
                                            className="h-full w-full max-h-full max-w-full object-cover"
                                            code='IGaDaZ5eRrfjFFe2UFID'/>
                                    </a>

                                </div>
                            </div>
                            {/*<SymbolCard*/}
                            {/*    url="/enamad"*/}
                            {/*    image={LOCAL_IMAGE_URL + "e-nomad.webp"}*/}
                            {/*    title="E-nomad"*/}
                            {/*/>*/}
                            <SymbolCard
                                url="/enamad"
                                image={LOCAL_IMAGE_URL + "ettahidie.webp"}
                                title="Ettahidie"
                            />

                            <div
                                className="block relative flex-grow bg-white rounded-[1.563rem] px-3.5 py-4 lg:p-5 after:absolute after:w-[38%] after:rounded-[1.938rem] after:h-1 after:bg-pol-blue-light after:top-0 after:right-[31%] hover:brightness-100 after:duration-300 hover:after:bg-pol-purple"
                            >
                                <div
                                    className="relative w-full h-[5.5rem] lg:h-[6.625rem] overflow-hidden rounded-[0.938rem]">

                                    <a target="_blank"
                                       referrerPolicy='origin'
                                       href="https://torob.com/shop/11886"
                                       rel="nofollow"
                                       className="h-full block"
                                    >
                                        <img alt=""
                                             style={{cursor: "pointer"}}
                                             className="h-full w-full max-h-full max-w-full object-cover"
                                             referrerPolicy='origin'
                                             src="https://api.torob.com/third-party/guarantee/v1/hologram/?instance_id=11886"
                                        />
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div
                    className="relative w-full bg-pol-blue pt-[1.813rem] pb-[3.188rem] lg:py-4 px-[1.938rem] xl:px-[6.5rem] flex items-center text-white">
                    <p className="text-xl font-bold hidden xl:block">راه‌های ارتباطی</p>
                    <ul className="flex-grow flex flex-col lg:flex-row lg:items-center lg:justify-between px-[2.375rem] lg:px-0 lg:mr-8 gap-y-5 lg:gap-y-0">
                        {
                            contact?.map((item, index) => (
                                <li key={index}>
                                    <Link href={item.link}
                                          className="flex items-center justify-between lg:justify-start">
                                        <div className="square-sm flex-center bg-pol-dark-blue-7">
                                            <div className="relative w-5 h-5">
                                                <ImageWithFallback
                                                    src={item.icon}
                                                    alt=""
                                                    className="object-cover"
                                                    fill
                                                />
                                            </div>
                                        </div>
                                        <p className="font-semibold mr-2.5">{item.title}</p>
                                    </Link>
                                </li>
                            ))
                        }
                    </ul>

                    <div className="w-full left-0 -bottom-5 absolute flex xl:hidden justify-center">
                        <ul className="flex space-x-2 space-x-reverse">
                            {
                                social_media?.map((item, index) => (
                                    <li key={index}>
                                        <Link href={item.link} className="flex items-center">
                                            <div className="square-md flex-center bg-white">
                                                <div className="relative w-5 h-5">
                                                    <ImageWithFallback
                                                        src={item.file}
                                                        alt={item.title}
                                                        className="object-cover"
                                                        fill
                                                    />
                                                </div>
                                            </div>
                                        </Link>
                                    </li>
                                ))
                            }
                        </ul>
                    </div>

                </div>

                <div
                    className="flex items-center justify-between pt-10 pb-8 lg:py-[0.938rem] px-[1.938rem] xl:px-[6.5rem] bg-pol-gray-light-7 lg:bg-pol-light-gray-2 ">
                    <div
                        className="font-semibold xl:flex text-sm text-pol-light-purple text-justify leading-[193%] lg:leading-[auto]">
                        {parse(copyright || "<span></span>")}
                    </div>

                    <ul className="hidden xl:flex space-x-2 space-x-reverse text-pol-blue">
                        {
                            social_media?.map((item, index) => (
                                <li key={index}>
                                    <Link href={item.link} className="flex items-center">
                                        <div className="square-md flex-center bg-white">
                                            <div className="relative w-5 h-5">
                                                <ImageWithFallback
                                                    src={item.file}
                                                    alt={item.title}
                                                    className="object-cover"
                                                    fill
                                                />
                                            </div>
                                        </div>
                                    </Link>
                                </li>
                            ))
                        }
                    </ul>

                </div>
            </div>
        </footer>
    )
}
